import apiClient from './client'
import type { SessionBoard } from '@shared/types/api'

/**
 * Одно занятие группы (occurrence): группа + дата + время начала. Отмена и
 * перенос касаются только его, постоянное расписание не меняется.
 */
export interface OccurrenceDTO {
  date: string
  start_time: string
  end_time: string
  location?: string
  session_id?: string
  cancelled: boolean
  extra: boolean
  marks: number
}

export interface OccurrenceTargetDTO {
  date: string
  start_time: string
  end_time: string
  location?: string
  /** В новом слоте было отменённое занятие: оно вернётся. */
  restores_cancelled: boolean
}

export type OccurrenceAction = 'cancel' | 'restore' | 'move'

export interface OccurrencePreviewRequest {
  date: string
  start_time: string
  action: OccurrenceAction
  to_date?: string
  to_start?: string
  to_end?: string
}

/** POST /groups/{id}/occurrence/preview - ничего не меняет. */
export interface OccurrencePreviewDTO {
  action: OccurrenceAction
  allowed: boolean
  /** has_marks | already_cancelled | not_cancelled | cancelled | slot_taken | same_slot */
  reason?: string
  occurrence: OccurrenceDTO
  target?: OccurrenceTargetDTO | null
}

export interface OccurrenceRef {
  date: string
  start_time: string
}

export interface OccurrenceMoveRequest extends OccurrenceRef {
  to_date: string
  to_start: string
  /** Нет - длительность сохраняется. */
  to_end?: string
}

export interface OccurrenceBoardResult {
  /** cancel: уже было отменено; restore: и так не отменено. */
  replayed: boolean
  board: SessionBoard
}

export interface OccurrenceMoveResult {
  replayed: boolean
  from: OccurrenceDTO
  to: OccurrenceDTO
}

export const occurrencesApi = {
  // POST /api/v1/groups/{groupId}/occurrence/preview
  preview: async (groupId: string, data: OccurrencePreviewRequest): Promise<OccurrencePreviewDTO> => {
    const response = await apiClient.post<OccurrencePreviewDTO>(`/groups/${groupId}/occurrence/preview`, data)
    return response.data
  },

  // POST /api/v1/groups/{groupId}/occurrence/cancel
  cancel: async (groupId: string, data: OccurrenceRef): Promise<OccurrenceBoardResult> => {
    const response = await apiClient.post<OccurrenceBoardResult>(`/groups/${groupId}/occurrence/cancel`, data)
    return response.data
  },

  // POST /api/v1/groups/{groupId}/occurrence/restore
  restore: async (groupId: string, data: OccurrenceRef): Promise<OccurrenceBoardResult> => {
    const response = await apiClient.post<OccurrenceBoardResult>(`/groups/${groupId}/occurrence/restore`, data)
    return response.data
  },

  // POST /api/v1/groups/{groupId}/occurrence/move
  move: async (groupId: string, data: OccurrenceMoveRequest): Promise<OccurrenceMoveResult> => {
    const response = await apiClient.post<OccurrenceMoveResult>(`/groups/${groupId}/occurrence/move`, data)
    return response.data
  },
}
